import { useQuery } from '@tanstack/react-query';
import {
  ReceivablesFilter,
  getReceivables,
  queryKeys,
} from '@vgrubs/components';

/**
 * The locations for a filter - every one (the default), only those that owe,
 * or those that used the vDrive reserve - with the totals and aging, which do
 * not change with the filter. One request, no paging: the backend sends the
 * whole list, highest owed first and the $0 rows last, A-Z.
 */
export const useReceivables = (filter: ReceivablesFilter = 'all') => {
  const query = useQuery({
    queryKey: queryKeys.admin.receivables.listBy(filter),
    queryFn: async () => {
      const { data } = await getReceivables(filter);
      return data.data;
    },
    placeholderData: (previous) => previous,
  });

  return {
    receivables: query.data ?? null,
    isLoading: query.isLoading,
    /** Also true while another filter's list replaces the one on screen. */
    isFetching: query.isFetching,
  };
};
